import * as MutationTypes from './mutation-types'
import AgendamentoService from '@/services/agendamento-service'
import { NotAuthenticatedError } from '../../models/not-authenticated-error'

export default {
  state: {
    agenda: [],
    exameSelecionado: {},
    AgendamentosDocumento: null
  },
  mutations: {
    [MutationTypes.SET_AGENDAMENTOS] (state, agenda) {
      state.agenda = agenda
    },
    [MutationTypes.SET_EXAME_DADOS] (state, exameSelecionado) {
      state.exameSelecionado = exameSelecionado
    },
    [MutationTypes.SET_LOADING_SCHEDULE] (state, isLoading) {
      state.isLoading = isLoading
    },
    [MutationTypes.SET_AGENDAMENTOS_DOCUMENTO] (state, value) {
      state.AgendamentosDocumento = value
    }
  },

  actions: {
    async getAgendamentosPDF({ commit }, payload) {
      commit('setLoadingState', true)
      await AgendamentoService.fetchAgendamentosPDF(payload)
        .then((res) => {
          if (!res.ok && res.status !== 200) {
            if (res.status === 401) throw new NotAuthenticatedError()
            throw new Error(`HTTP error, status ${res.status}`)
          }
          return res.data
        })
        .then((arquivo) => {
          commit(MutationTypes.SET_AGENDAMENTOS_DOCUMENTO, arquivo)
          commit('setLoadingState', false)
        })
        .catch((err) => {
          commit('setLoadingState', false)
          throw err
        })
    },
    async getAgendamentos({ commit }) {
      commit('setLoadingState', true)
      await AgendamentoService.getAgendamentos()
        .then((res) => {
          if (!res.ok && res.status !== 200) {
            if (res.status === 401) throw new NotAuthenticatedError()
            throw new Error(`HTTP error, status ${res.status}`)
          }
          if (res.status === 204) return []
          return res.json()
        })
        .then((dados) => {
          commit(MutationTypes.SET_AGENDAMENTOS, dados)
          commit('setLoadingState', false)
        })
        .catch((err) => {
          commit('setLoadingState', false)
          throw err
        })
    },
    async getDadosExame({ commit }, payload) {
      if (payload == null) {
        commit(MutationTypes.SET_EXAME_DADOS, null)
        return
      }
      commit('setLoadingState', true)
      await AgendamentoService.getDadosExame(payload)
        .then(async (res) => {
          if (!res.ok && res.status !== 200) {
            if (res.status === 401) throw new NotAuthenticatedError()
            throw new Error(`HTTP error, status ${res.status}`)
          }
          var dados = await res.json()
          commit(MutationTypes.SET_EXAME_DADOS, dados)
        })
        .finally(() => {
          commit('setLoadingState', false)
        })
    }
  },

  getters: {
    Agendamentos: state => state.agenda,
    ExameSelecionado: state => state.exameSelecionado,
    getIsLoadingSchedule: state => state.isLoading,
    AgendamentosDocumento: state => state.AgendamentosDocumento
  }
}
